import React from 'react';
import './locales/i18n';
import AppRoutes from './routes/AppRoutes';
import { useDefaultLanguage } from './hooks/useDefaultLanguage';
import { useContentProtection } from './hooks/useContentProtection';
import { ConsultationProvider } from './contexts/ConsultationContext';

function App() {
  useDefaultLanguage(); // Ensure Vietnamese is default language
  useContentProtection(); // Enable content protection

  return (
    <ConsultationProvider>
      <AppRoutes />
    </ConsultationProvider>
  );
}

export default App;
